import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";
import { PanelStore } from "./types";

interface StoreFilterRowProps {
  store: PanelStore;
  selected: boolean;
  onToggle: () => void;
}

/** Linha da lista: código em destaque + nome, e "UF · Cidade" abaixo. */
export function StoreFilterRow({ store, selected, onToggle }: StoreFilterRowProps) {
  const location = [store.state, store.city].filter(Boolean).join(" · ");

  return (
    <label
      className={cn(
        "flex cursor-pointer items-start gap-2 rounded-sm px-2 py-1.5 transition-colors",
        selected ? "bg-accent" : "hover:bg-muted",
      )}
    >
      <Checkbox checked={selected} onCheckedChange={onToggle} className="mt-0.5" />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="font-mono text-sm font-semibold">{store.code}</span>
          <span className="truncate text-sm text-foreground">{store.name}</span>
        </div>
        {location && <p className="text-xs text-muted-foreground">{location}</p>}
      </div>
    </label>
  );
}
